import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../HeaderComponent';
import LoadingComponent from '../LoadingComponent';
import Modal from '../Modal';

import css from '../../styles/instrument/insiders';

class Insiders extends Component {
    static propTypes = {
        title: PropTypes.string,
        insiders: PropTypes.array,
        isLoading: PropTypes.bool,
        modalOpen: PropTypes.bool,
        openModal: PropTypes.func,
        closeModal: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this._getName = (firstName, lastName) => {
            if (!firstName || !lastName) {
                return firstName || lastName || '-';
            }

            return `${firstName} ${lastName}`;
        };

        this._getTitle = (commission, title) => {
            if (!commission && !title) {
                return '-';
            }

            return commission || title;
        };
    }

    renderModal() {
        if (!this.props.modalOpen) return null;

        return (
            <Modal
                title={this.props.t('insiders.title')}
                symbol={this.props.title}
                onClick={this.props.closeModal}
            >
                <div className={css.modalWrapper}>
                    <table className={css.table}>
                        <thead className={css.thead}>
                            <tr>
                                <th>&nbsp;</th>
                                <th className={css.alignRight}>{this.props.t('insiders.score')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderInsiders()}
                        </tbody>
                    </table>
                </div>
            </Modal>
        );
    }

    renderInsiders(limit) {
        const { insiders } = this.props;

        const rows = [];

        let count = 0;

        for (const i in insiders) {
            if (insiders.hasOwnProperty(i)) {
                count++;

                if (limit && count > limit) {
                    break;
                }

                const insider = insiders[i];
                rows.push(
                    <tr className={css.tableRow} key={i}>
                        <td>
                            {this._getName(insider.FIRST_NAME_, insider.LAST_NAME_)}
                        </td>
                        <td className={css.alignRight}>
                            {this._getTitle(insider.COMMISSION_, insider.TITLE_)}
                        </td>
                    </tr>
                );
            }
        }

        return rows;
    }

    renderContent() {
        if (!this.props.insiders.length) {
            return <LoadingComponent height={279} />;
        }

        return (
            <div className={css.tableWrapper}>
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th>&nbsp;</th>
                            <th className={css.alignRight}>{this.props.t('insiders.score')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderInsiders(5)}
                    </tbody>
                </table>
                {this.renderModal()}
            </div>
        );
    }

    render() {
        if (!this.props.insiders.length && !this.props.isLoading) {
            return null;
        }

        const { t } = this.props;

        return (
            <HeaderComponent
                title={t('insiders.title')}
                label={t('common:seeAll')}
                onclick={() => this.props.openModal('insiders')}
            >
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Insiders);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Insiders.js
 **/